<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="list-row">
    <v-card
        class="clickable"
        v-if="display==='list'"
        @click="$root.$emit('openPromotion', {object:promotion})"
    >
      <PromotionRowList :is_loading="is_loading" :onClickAddCart="onClickAddCart"
                        :promotion="promotion"></PromotionRowList>
    </v-card>
    <v-card
        v-if="display==='column2'"
        @click="$root.$emit('openPromotion', {object:promotion})"
    >
      <PromotionRowColumn2 :is_loading="is_loading" :onClickAddCart="onClickAddCart"
                           :promotion="promotion"></PromotionRowColumn2>
    </v-card>
    <v-card
        v-if="display==='grid'"
        @click="$root.$emit('openPromotion', {object:promotion})"
    >
      <PromotionRowGrid :is_loading="is_loading" :onClickAddCart="onClickAddCart"
                        :promotion="promotion"></PromotionRowGrid>
    </v-card>
  </div>

</template>
<style lang="scss" scoped>
.stock {
  font-size: 20px;
}

.unit {
  font-size: 0.5em;
}

.percent {
  font-size: 0.7em;
}

.currency {
  /*display: block;*/
  /*width: 32px;*/
  /*float: right;*/
  font-size: 0.7em;
}

</style>

<script lang="ts">

import {ProductPromotion} from '@/models/ProductPromotion'
import {Promotion, PromotionGroupConst} from '@/models/Promotion'
import {Component, Prop, Vue} from 'vue-property-decorator'
import router from '../../router'
import PromotionRowColumn2 from './PromotionRowColumn2.vue'
import PromotionRowGrid from './PromotionRowGrid.vue'
import PromotionRowList from './PromotionRowList.vue'

@Component({
  components: {PromotionRowColumn2, PromotionRowList, PromotionRowGrid},
})
export default class PromotionRow extends Vue {
  @Prop() promotion: Promotion
  @Prop() currentIndex: number
  @Prop({default: 'list'}) display: string

  is_loading: Boolean = false

  PromotionGroupConst = PromotionGroupConst


  async onClickAddCart(promotion: Promotion, delta = 1) {

    if (['D', 'T'].includes(promotion.promotion_type)) {
      this.$root.$emit('openPromotion', {object:promotion})
      return
    }

    if (this.$store.state.carts.current.id) {
      if (promotion.price_group != this.$store.state.carts.current.price_group) {
        this.$root.$emit('onWarning', {message: 'ไม่สามารถสั่งโปรโมชั่น ' + PromotionGroupConst.map(promotion.price_group || 1) + ' ได้ เนื่องจากลูกค้าใช้ราคา ' + PromotionGroupConst.map(this.$store.state.carts.current.price_group) + ' อยู่'})
      }else if (promotion.amount_limit && promotion.amount_limit > 0 && promotion.amount_sold &&
          promotion.amount_sold + delta>promotion.amount_limit) {
          this.$root.$emit('onWarning', {message: 'โปรโมชั่นครบจำนวนแล้ว'})
      } else {
        this.is_loading = true
        for (let i in promotion.product_promotions) {
          const pp: ProductPromotion = promotion.product_promotions[i]
          if (pp && pp.product) {
            const product = pp.product
            product.price_retail = pp.display_price
            product['price_' + promotion.price_group] = pp.display_price
            await this.$store.dispatch('alter_item_to_cart', {
              product,
              delta: delta,
              promotion: promotion,
              product_promotion: pp,
              index: parseInt(i),
            })
          }
        }
        this.is_loading = false
      }
    } else {
      this.$root.$emit('onWarning', {message: 'กรุณาเลือกลูกค้าก่อนสั่งสินค้า'})
      router.push('/customer')
    }
  }
}

</script>
